<section
  [id]="data?.id"
  class="vm-row vm-countdown-section"
  [ngClass]="{ center: data?.type === globalElementType.CountdownCenterAligned }">
  <div *ngIf="data?.title" class="vm-col-sm-12">
    <h2>{{ data?.title }}</h2>
  </div>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy" class="vm-col-sm-12"></vm-markdown>
  <div class="countdown">
    <div class="countdown__segment" aria-hidden="true" data-testid="days-segment">
      <div class="countdown__flip-cards" data-testid="days-flip-cards">
        <vm-flip-card [value]="this.days | base10: 2"></vm-flip-card>
        <vm-flip-card [value]="this.days | base10"></vm-flip-card>
      </div>
      <div class="countdown__label" data-testid="days-label">
        <span>Days</span>
      </div>
    </div>

    <div class="countdown__segment" aria-hidden="true" data-testid="hours-segment">
      <div class="countdown__flip-cards" data-testid="hours-flip-cards">
        <vm-flip-card [value]="this.hours | base10: 2"></vm-flip-card>
        <vm-flip-card [value]="this.hours | base10"></vm-flip-card>
      </div>
      <div class="countdown__label" data-testid="hours-label">
        <span>Hours</span>
      </div>
    </div>

    <div class="countdown__segment" aria-hidden="true" data-testid="minutes-segment">
      <div class="countdown__flip-cards" data-testid="minutes-flip-cards">
        <vm-flip-card [value]="this.minutes | base10: 2"></vm-flip-card>
        <vm-flip-card [value]="this.minutes | base10"></vm-flip-card>
      </div>
      <div class="countdown__label" data-testid="minutes-label">
        <span>Minutes</span>
      </div>
    </div>

    <div class="countdown__segment" aria-hidden="true" data-testid="seconds-segment">
      <div class="countdown__flip-cards" data-testid="seconds-flip-cards">
        <vm-flip-card [value]="this.seconds | base10: 2"></vm-flip-card>
        <vm-flip-card [value]="this.seconds | base10"></vm-flip-card>
      </div>
      <div class="countdown__label" data-testid="seconds-label">
        <span>Seconds</span>
      </div>
    </div>
  </div>
</section>
